import { css, cx } from '@fable/theme'
import { StreakCalendarMonths } from './StreakCalendarMonths'
import { StreakCalendarLegend } from './StreakCalendarLegend'
import { StreakCalendarGrid } from './StreakCalendarGrid'
import { useInView } from 'framer-motion'
import { useRef } from 'react'
import { StreakCalendarMotion } from './StreaksCalendarMotion'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  animate?: boolean
}

export const StreakCalendar = ({
  animate = false,
  className = '',
  ...props
}: Props) => {
  const ref = useRef(null)
  const gridInView = useInView(ref, {
    once: true,
    amount: 1,
    margin: '0px 0px 200px 0px',
  })

  return (
    <div
      ref={ref}
      className={cx(
        css`
          margin-top: ${animate ? '16px' : '4px'};
        `,
        className
      )}
      {...props}
    >
      {animate ? <StreakCalendarMonths inView={gridInView} /> : null}
      {animate ? (
        <StreakCalendarMotion inView={gridInView}>
          <StreakCalendarGrid inView={gridInView} animate />
        </StreakCalendarMotion>
      ) : (
        <StreakCalendarGrid />
      )}
      <StreakCalendarLegend />
    </div>
  )
}
